import { render, staticRenderFns } from "./ProjectKanban.vue?vue&type=template&id=daa0448a&scoped=true&"
import script from "./ProjectKanban.vue?vue&type=script&lang=js&"
export * from "./ProjectKanban.vue?vue&type=script&lang=js&"
import style0 from "./ProjectKanban.vue?vue&type=style&index=0&id=daa0448a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa0448a",
  null
  
)

export default component.exports